import { getQueryMethod, resources, entities, methods, getURLParams } from '../utils';
const { meloAPI } = resources;
const { suppliers } = entities;
const { POST, PATCH, DELETE } = methods;

const query = getQueryMethod(meloAPI, suppliers);

const endpoints = {
  createSupplier: async (businessId, supplierData) => {
    return await query('', POST, { businessId, ...supplierData });
  },
  getSupplier: async (businessId, supplierId) => {
    return await query(`${businessId}/${supplierId}`);
  },
  getSupplierByIdentification: async (businessId, identificationNumber) => {
    return await query(`${businessId}/${identificationNumber}/by-identification`);
  },
  updateSupplier: async (businessId, supplierId, supplierData) => {
    return await query(`${businessId}/${supplierId}`, PATCH, supplierData);
  },
  deleteSupplier: async (businessId, supplierId) => {
    return await query(`${businessId}/${supplierId}`, DELETE);
  },
  getSuppliersPaginated: async ({ businessId, ...params }) => {
    const queryParams = getURLParams(params);
    return await query(`${businessId}?${queryParams}`);
  },
  getSuppliersByIds: async (businessId, suppliersIds) => {
    const queryParams = getURLParams(suppliersIds);
    return await query(`${businessId}/by/ids?${queryParams}`);
  },
  getSuppliersByStatus: async ({ businessId, paymentStatus }) => {
    const queryParams = getURLParams({ paymentStatus });
    return await query(`${businessId}/by/status?${queryParams}`);
  },
  getAllSuppliers: async businessId => {
    return await query(`${businessId}/by/all`);
  },
  getSupplierPurchases: async ({ supplierId, state }) => {
    const queryParams = getURLParams({ state });
    return await query(`${supplierId}/purchases/by-payment?${queryParams}`);
  },
  getSupplierPurchasesPaginated: async ({ supplierId, ...params }) => {
    const queryParams = getURLParams(params);
    return await query(`${supplierId}/purchases/by-payment/paginated?${queryParams}`);
  },
  deleteSupplierDruoBanksAccounts: async (businessId, supplierId, druoAccountsIds) => {
    return await query('bank/delete/accounts', PATCH, { businessId, supplierId, druoAccountsIds });
  },
  createSuppliersByFile: async (businessId, filePath) => {
    return await query('suppliers/batch', POST, { businessId, filePath });
  },
  getSuppliersBatchCreationById: async suppliersbatchId => {
    return await query(`suppliers/batch/creation/by/${suppliersbatchId}`);
  }
};

export default endpoints;
